import {version} from '../../package.json';

import Vue from 'vue'
import Vuex from 'vuex'
import debounce from 'lodash/debounce'
import createPersistedState from 'vuex-persistedstate'
import lang from './modules/lang'
import users from './modules/users'
import utils from './modules/utils'
import layout from './modules/layout'
import entities from './modules/entities'
import dashboards from './modules/dashboards'
import widgetCreation from '@/store/modules/widgetCreation'
import templatesCategory from './modules/templatesCategory'
import axiosRequestsDuration from './modules/axiosRequestsDuration'
import sound from './modules/sound'
import * as shvl from 'shvl'

import reportTrigger from '@/modules/reports/store/reportTrigger'

Vue.use(Vuex)

export const STORAGE_KEY = 'realTimeDashboardApp'
const STORAGE_TOKEN_KEY = 'dashboardAppTokenStorageKey'
const STORAGE_DASHBOARD_VERSION_KEY = 'dashboardVersion'

function clearStorage() {
    localStorage.clear()
}

const storageToken = localStorage.getItem(STORAGE_TOKEN_KEY)
const storageVersion = localStorage.getItem(STORAGE_DASHBOARD_VERSION_KEY)

const urlParams = new URLSearchParams(window.location.search)
const urlToken = urlParams.get('token')

const tokenChanged = urlToken && urlToken !== storageToken
const versionChanged =  storageVersion !== version

if (tokenChanged) {
    console.log('[DETECTED TOKEN CHANGE]')
}

if (versionChanged) {
    console.log('[DETECTED VERSION CHANGE]')
}

if (tokenChanged || versionChanged) {
    console.log('[CLEARING CACHE]')
    clearStorage()

    localStorage.setItem(STORAGE_TOKEN_KEY, urlToken)
    localStorage.setItem(STORAGE_DASHBOARD_VERSION_KEY, version)
}


function reducer (state, paths) {
    return Array.isArray(paths)
        ? paths.reduce(
            function (substate, path) {
                return shvl.set(substate, path, shvl.get(state, path));
            },
            {}
        )
        : state
}

function reduceStore (state, paths) {
    const sanitizedState = reducer(state, paths)

    sanitizedState.templatesCategory.templates = (sanitizedState.templatesCategory.templates || [])
        .map(({ TemplateID, TemplateName, TemplateNameContentTag, TemplateSettings }) => {
            return {
                TemplateID,
                TemplateName,
                TemplateNameContentTag,
                TemplateSettings
            }
        })

    sanitizedState.dashboards.activeDashboard.WidgetGroupList = (sanitizedState.dashboards.activeDashboard.WidgetGroupList || [])
        .map(({ WidgetGroupTitle, Order, WidgetGroupID, WidgetList }) => {
            let resultedWidgetList = []

            if (String(WidgetGroupID) === String(sanitizedState.dashboards.activeWidgetGroupID)) {
                resultedWidgetList = WidgetList.map(({ TemplateID, Title, WidgetID, WidgetLayout }) => {
                    const widgetLayout = {}

                    if (WidgetLayout) {
                        widgetLayout.ComponentTypeID = WidgetLayout.ComponentTypeID
                        widgetLayout.GridLayout = WidgetLayout.GridLayout
                        widgetLayout.Order = WidgetLayout.Order
                    }

                    return {
                        loadedFromCache: true,
                        Title,
                        TemplateID,
                        WidgetID,
                        WidgetLayout: widgetLayout
                    }
                })
            }

            return {
                WidgetGroupTitle,
                Order,
                WidgetGroupID,
                WidgetList: resultedWidgetList
            }
        })

    sanitizedState.dashboards.allDashboards = (sanitizedState.dashboards.allDashboards || [])
        .map((dashboardData) => {
            return {
                ...dashboardData,
                WidgetGroupList: []
            }
        })

    return sanitizedState
}

const store = new Vuex.Store({
    plugins: [
        createPersistedState({
            key: STORAGE_KEY,
            paths: [
                'users',
                'lang',
                'layout',
                'templatesCategory.all',
                'templatesCategory.templates',
                'dashboards.activeDashboard.DashboardID',
                'dashboards.activeDashboard.DashboardLayoutID',
                'dashboards.activeDashboard.DashboardTitle',
                'dashboards.activeDashboard.DashBoardsUserPermission',
                'dashboards.activeDashboard.AccountID',
                'dashboards.activeDashboard.WidgetGroupList',
                'dashboards.allDashboards',
                'dashboards.activeWidgetGroupID',
                'dashboards.editMode',
                'entities.selectedAccountID',
                'entities.entitiesList.Accounts',
                'entities.entitiesList.Users',
                'entities.entitiesList.Extension',
                'entities.entitiesList.DIDs',
                'entities.entitiesList.Queues',
                'entities.entitiesList.Campaigns'
            ],
            reducer: debounce(reduceStore, 1000)
        })
    ],
    modules: {
        lang,
        utils,
        users,
        layout,
        entities,
        dashboards,
        widgetCreation,
        templatesCategory,
        reportTrigger,
        axiosRequestsDuration,
        sound
    }
})

export default store
